import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa76d4b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./nutrition-step-five.scss?vue&type=style&index=0&id=fa76d4b6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76d4b6",
  null
  
)

export default component.exports